var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDecoration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 186,
    viewBox: "0 0 175 186",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45.7255,
    height: 128.51,
    transform: "matrix(-0.984808 -0.173649 0.173648 -0.984808 174.314 152.999)",
    fill: "#5351C0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 45.7256,
    height: 128.511,
    transform: "matrix(-5.42151e-07 -1 1 6.02504e-07 39.329 37.855)",
    fill: "#5351C0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 82.6672,
    y: 123.65,
    width: 45.7256,
    height: 149.98,
    transform: "rotate(-130 82.6672 123.65)",
    fill: "#7D7BB7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecoration);
export default __webpack_public_path__ + "static/media/decoration.00c940498f82913325c42617958b2945.svg";
export { ForwardRef as ReactComponent };